<template>
    <header class="app-header fixed-top">
        <div class="app-header-inner">
            <div class="container-fluid py-2">
                <div class="app-header-content">
                    <div class="row justify-content-between align-items-center">
                        <div class="col-auto">
                            <a id="sidepanel-toggler" class="sidepanel-toggler d-inline-block d-xl-none"
                                @click="onMenuClick()">
                                <i class="fas fa-bars"></i>
                            </a>
                        </div>

                        <div class="app-utilities col-auto">
                            <div class="app-utility-item">
                                <span class="text-muted small">Welcome to {{ org }}, {{ givenName }}.</span>
                            </div>
                            <div class="app-utility-item app-user-dropdown dropdown">
                                <a class="dropdown-toggle" id="user-dropdown-toggle" data-bs-toggle="dropdown" href="#"
                                    role="button" aria-expanded="false">
                                    <i class="fas fa-user-circle lead"></i>
                                </a>
                                <ul class="dropdown-menu" aria-labelledby="user-dropdown-toggle">
                                    <li>
                                        <a class="dropdown-item" href="#" @click="switchOrg">Switch Org</a>
                                    </li>
                                    <li>
                                        <a class="dropdown-item" href="#" @click="logOut">Log Out</a>
                                    </li>
                                </ul>
                            </div>
                            <!--//app-user-dropdown-->
                        </div>
                        <!--//app-utilities-->
                    </div>
                    <!--//row-->
                </div>
                <!--//app-header-content-->
            </div>
            <!--//container-fluid-->
        </div>
        <!--//app-header-inner-->
        <div id="app-sidepanel" class="app-sidepanel">
            <div id="sidepanel-drop" class="sidepanel-drop"></div>
            <div class="sidepanel-inner d-flex flex-column">
                <a href="#" id="sidepanel-close" class="sidepanel-close d-xl-none" @click="onMenuClose()">&times;</a>
                <div class="app-branding">
                    <router-link class="app-logo" to="/admin"><img class="logo-icon me-2"
                            :src="require('@/assets/logo.png')" alt="logo" /><span
                            class="logo-text">Agenda</span></router-link>
                </div>
                <!--//app-branding-->

                <nav id="app-nav-main" class="app-nav app-nav-main flex-grow-1">
                    <ul class="app-menu list-unstyled accordion" id="menu-accordion">
                        <li class="nav-item">
                            <!--//Bootstrap Icons: https://icons.getbootstrap.com/ -->
                            <router-link class="nav-link active" to="/admin">
                                <span class="nav-icon">
                                    <i class="fas fa-home"></i>
                                </span>
                                <span class="nav-link-text">Overview</span>
                            </router-link>
                            <!--//nav-link-->
                        </li>
                        <!--//nav-item-->

                        <li class="nav-item has-submenu">
                            <!--//Bootstrap Icons: https://icons.getbootstrap.com/ -->
                            <a class="nav-link submenu-toggle" href="/agendas" data-bs-toggle="collapse"
                                data-bs-target="#submenu-1" aria-expanded="false" aria-controls="submenu-1">
                                <span class="nav-icon">
                                    <!--//Bootstrap Icons: https://icons.getbootstrap.com/ -->
                                    <i class="fas fa-calendar"></i>
                                </span>
                                <span class="nav-link-text">Agendas</span>
                                <span class="submenu-arrow">
                                    <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-chevron-down"
                                        fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd"
                                            d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z" />
                                    </svg>
                                </span>
                                <!--//submenu-arrow-->
                            </a>
                            <!--//nav-link-->
                            <div id="submenu-1" class="collapse submenu submenu-1" data-bs-parent="#menu-accordion">
                                <ul class="submenu-list list-unstyled">
                                    <li class="submenu-item">
                                        <router-link to="/admin/agendas/new" class="submenu-link">Create
                                            New</router-link>
                                    </li>
                                    <li class="submenu-item">
                                        <router-link to="/admin/agendas" class="submenu-link">Manage</router-link>
                                    </li>
                                </ul>
                            </div>
                        </li>
                        <!--//nav-item-->

                        <li class="nav-item has-submenu">
                            <!--//Bootstrap Icons: https://icons.getbootstrap.com/ -->
                            <a class="nav-link submenu-toggle" href="/contacts" data-bs-toggle="collapse"
                                data-bs-target="#submenu-5" aria-expanded="false" aria-controls="submenu-5">
                                <span class="nav-icon">
                                    <!--//Bootstrap Icons: https://icons.getbootstrap.com/ -->
                                    <i class="fas fa-user"></i>
                                </span>
                                <span class="nav-link-text">Contacts</span>
                                <span class="submenu-arrow">
                                    <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-chevron-down"
                                        fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd"
                                            d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z" />
                                    </svg>
                                </span>
                                <!--//submenu-arrow-->
                            </a>
                            <!--//nav-link-->
                            <div id="submenu-5" class="collapse submenu submenu-1" data-bs-parent="#menu-accordion">
                                <ul class="submenu-list list-unstyled">
                                    <li class="submenu-item">
                                        <router-link to="/admin/contacts/new" class="submenu-link">Create
                                            New</router-link>
                                    </li>
                                    <li class="submenu-item">
                                        <router-link to="/admin/contacts" class="submenu-link">Manage</router-link>
                                    </li>
                                    <li class="submenu-item">
                                        <router-link to="/admin/contacts/inactivity-policy" class="submenu-link">Inactivity Policy</router-link>
                                    </li>
                                </ul>
                            </div>
                        </li>

                        <li class="nav-item has-submenu">
                            <!--//Bootstrap Icons: https://icons.getbootstrap.com/ -->
                            <a class="nav-link submenu-toggle" href="/categories" data-bs-toggle="collapse"
                                data-bs-target="#submenu-2" aria-expanded="false" aria-controls="submenu-2">
                                <span class="nav-icon">
                                    <!--//Bootstrap Icons: https://icons.getbootstrap.com/ -->
                                    <i class="fas fa-tags"></i>
                                </span>
                                <span class="nav-link-text">Categories</span>
                                <span class="submenu-arrow">
                                    <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-chevron-down"
                                        fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd"
                                            d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z" />
                                    </svg>
                                </span>
                                <!--//submenu-arrow-->
                            </a>
                            <!--//nav-link-->
                            <div id="submenu-2" class="collapse submenu submenu-2" data-bs-parent="#menu-accordion">
                                <ul class="submenu-list list-unstyled">
                                    <li class="submenu-item">
                                        <router-link to="/admin/categories/new" class="submenu-link">Create
                                            New</router-link>
                                    </li>
                                    <li class="submenu-item">
                                        <router-link to="/admin/categories" class="submenu-link">Manage</router-link>
                                    </li>
                                </ul>
                            </div>
                        </li>
                        <!--//nav-item-->

                        <li class="nav-item has-submenu">
                            <!--//Bootstrap Icons: https://icons.getbootstrap.com/ -->
                            <a class="nav-link submenu-toggle" href="/admin/locations" data-bs-toggle="collapse"
                                data-bs-target="#submenu-3" aria-expanded="false" aria-controls="submenu-3">
                                <span class="nav-icon">
                                    <!--//Bootstrap Icons: https://icons.getbootstrap.com/ -->
                                    <i class="fas fa-map-pin"></i>
                                </span>
                                <span class="nav-link-text">Locations</span>
                                <span class="submenu-arrow">
                                    <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-chevron-down"
                                        fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd"
                                            d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z" />
                                    </svg>
                                </span>
                                <!--//submenu-arrow-->
                            </a>
                            <!--//nav-link-->
                            <div id="submenu-3" class="collapse submenu submenu-3" data-bs-parent="#menu-accordion">
                                <ul class="submenu-list list-unstyled">
                                    <li class="submenu-item">
                                        <router-link to="/admin/locations/new" class="submenu-link">Create
                                            New</router-link>
                                    </li>
                                    <li class="submenu-item">
                                        <router-link to="/admin/locations" class="submenu-link">Manage</router-link>
                                    </li>
                                </ul>
                            </div>
                        </li>
                        <!--//nav-item-->

                        <li class="nav-item has-submenu">
                            <!--//Bootstrap Icons: https://icons.getbootstrap.com/ -->
                            <a class="nav-link submenu-toggle" href="/groups" data-bs-toggle="collapse"
                                data-bs-target="#submenu-4" aria-expanded="false" aria-controls="submenu-4">
                                <span class="nav-icon">
                                    <!--//Bootstrap Icons: https://icons.getbootstrap.com/ -->
                                    <i class="fas fa-users"></i>
                                </span>
                                <span class="nav-link-text">Groups</span>
                                <span class="submenu-arrow">
                                    <svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-chevron-down"
                                        fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd"
                                            d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z" />
                                    </svg>
                                </span>
                                <!--//submenu-arrow-->
                            </a>
                            <!--//nav-link-->
                            <div id="submenu-4" class="collapse submenu submenu-4" data-bs-parent="#menu-accordion">
                                <ul class="submenu-list list-unstyled">
                                    <li class="submenu-item">
                                        <router-link to="/admin/groups/new" class="submenu-link">Create
                                            New</router-link>
                                    </li>
                                    <li class="submenu-item">
                                        <router-link to="/admin/groups" class="submenu-link">Manage</router-link>
                                    </li>
                                </ul>
                            </div>
                        </li>
                        <!--//nav-item-->
                    </ul>
                    <!--//app-menu-->
                </nav>
                <!--//app-nav-->
                <div class="app-sidepanel-footer">
                    <nav class="app-nav app-nav-footer">
                        <ul class="app-menu footer-menu list-unstyled">
                            <li class="nav-item">
                                <!--//Bootstrap Icons: https://icons.getbootstrap.com/ -->
                                <a class="nav-link d-flex align-items-center" href="https://periapsys.com/#contact"
                                    target="_blank">
                                    <span class="nav-icon">
                                        <i class="bi bi-info-circle" style="position: relative; top: 3px;"></i>
                                    </span>
                                    <span class="nav-link-text">Help</span>
                                </a>
                                <!--//nav-link-->
                            </li>
                            <!--//nav-item-->
                        </ul>
                        <!--//footer-menu-->
                    </nav>
                </div>
                <!--//app-sidepanel-footer-->
            </div>
            <!--//sidepanel-inner-->
        </div>
        <!--//app-sidepanel-->
    </header>
    <!--//app-header-->
</template>

<script>
import { jwtDecode } from "jwt-decode";
import { logout } from '@/services/oidc.service';
export default {
    data() {
        return {
            org: localStorage.getItem("org")
        };
    },
    computed: {
        givenName() {
            const token = localStorage.getItem("token");

            if (!token) return "";

            try {
                return jwtDecode(token).given_name || "";
            } catch {
                return "";
            }
        }
    },
    methods: {
        onMenuClick() {
            document
                .getElementById("app-sidepanel")
                .classList.add("sidepanel-visible");
        },

        onMenuClose() {
            document
                .getElementById("app-sidepanel")
                .classList.remove("sidepanel-visible");
        },

        logOut() {
            localStorage.clear();
            logout();
        },

        switchOrg() {
            localStorage.removeItem("org");
            window.location.href = "/admin/init";
        },
    }
}
</script>